<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _OPEN_CONFIRMATION_ } from '_modules/product/components/ProductModel';

export default {
  name: 'product-buttons',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      const params = {
        type: 'product',
        object: this.product,
        message: 'Produto deletado com sucesso!',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
  },
  mounted() {},
};
</script>
